export enum ApplicationValidationStage {
	NotValidating,
	TermsAndConditionsCompleted,
	DocumentRequestsCompleted,
	ApplicationSubmittable,
	EsignEmailsSending
}
